/********** MAIN **********/
export const MAIN_FETCHING_ACTION = 'MAIN_FETCHING_ACTION';

export const SET_URL_HASH_DATA = 'SET_URL_HASH_DATA';

export const FETCH_SHARE_REQUEST = 'FETCH_SHARE_REQUEST';
export const FETCH_EVENT_REQUEST = 'FETCH_EVENT_REQUEST';
export const FETCH_EVENT_HIGHLIGHT_REQUEST = 'FETCH_EVENT_HIGHLIGHT_REQUEST';
export const FETCH_PLAYER_HIGHLIGHT_REQUEST = 'FETCH_PLAYER_HIGHLIGHT_REQUEST';
export const FETCH_PLAYER_HIGHLIGHTS_REQUEST = 'FETCH_PLAYER_HIGHLIGHTS_REQUEST';
export const MAIN_FETCH_SUCCESS = 'MAIN_FETCH_SUCCESS';
export const MAIN_FETCH_FAILURE = 'MAIN_FETCH_FAILURE';

export const ADD_STREAMS = 'ADD_STREAMS';
export const CHANGE_ACTIVE_PLAYBACK = 'CHANGE_ACTIVE_PLAYBACK';
export const SET_ACTIVE_PLAYBACK = 'SET_ACTIVE_PLAYBACK';

export const CREATE_SHARED_LINK_ACTION = 'CREATE_SHARED_LINK_ACTION';
export const CREATE_SHARED_LINK_LOADING = 'CREATE_SHARED_LINK_LOADING';
export const CREATE_SHARED_LINK_SUCCESS = 'CREATE_SHARED_LINK_SUCCESS';
export const CREATE_SHARED_LINK_FAILURE = 'CREATE_SHARED_LINK_FAILURE';

export const REFRESH_SHARED_LINKS_LIST= 'REFRESH_SHARED_LINKS_LIST';
export const CLEAR_SHARED_LINKS_LIST = 'CLEAR_SHARED_LINKS_LIST';

export const CREATE_PLAYBACK_LINK = 'CREATE_PLAYBACK_LINK';
export const CREATE_DEEP_LINK_REQUEST = 'CREATE_DEEP_LINK_REQUEST';

export const ADD_THUMBNAIL = 'ADD_THUMBNAIL';

export const SET_EVENT_DATA = 'SET_EVENT_DATA';

export const SET_ADDITIONAL_EVENT_TOKENS = 'SET_ADDITIONAL_EVENT_TOKENS';
export const SWITCH_TO_NEARBY_EVENT = 'SWITCH_TO_NEARBY_EVENT';
export const INIT_VIDEO_DATA = 'INIT_VIDEO_DATA';

/********** ASYNC LOADING **********/
export const LOAD_WEB_SDK_REQUEST = 'LOAD_WEB_SDK_REQUEST';
export const LOAD_WEB_SDK_SUCCESS = 'LOAD_WEB_SDK_SUCCESS';
export const LOAD_WEB_SDK_FAILURE = 'LOAD_WEB_SDK_FAILURE';

/********** NOTIFICATIONS **********/
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
